export default "__VITE_ASSET__DyxbhTZv__"